import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import type { LoadStatus } from '@apps/stays/types';

export const accommodationsConsoleTelemetry = createTelemetryObject({
  actions: {
    pageViewed: () => ({
      category: 'wedding',
      action: 'PageViewed',
      extraInfo: {
        name: 'AccommodationsConsole',
      },
    }),
    onAccommodationsResultsLoaded: ({ accommodations_results_loaded_ms, load_status }: { accommodations_results_loaded_ms: number; load_status: LoadStatus }) => ({
      category: 'wedding',
      action: 'TravelButtonInteracted',
      extraInfo: {
        name: 'AccommodationsResultsLoaded',
        accommodations_results_loaded_ms,
        load_status,
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(accommodationsConsoleTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useAccommodationsConsoleTelemetry };
